import React, { useState, useEffect, useRef } from 'react';
import { hot } from 'react-hot-loader';
import { connect } from 'react-redux';
import Link from 'redux-first-router-link';
import Top from '../Top/Top';
import TemplateParser from '../Templates/TemplateParser';
import TemplateParserDeprecated from '../Templates/TemplateParserDeprecated';
import Event from '../Event/Event';
import { translate, prefix, urlify } from '../../utils/string';
import { offset, scrollTo } from '../../utils/dom';
import { translateObjectDefaultData, translateObjectData } from '../../utils/locale';
import { deepClone } from '../../utils/object';
import s from './Page.scss';

const Page = ({ data, footer, setup, currentPath, ...props }) => {
	const [aboutExpanded, setAboutExpanded] = useState(false);
	const pageElement = useRef();

	useEffect(() => {
		if (props.hashLocation || window.location.hash !== '') scrollToHash();
	}, [props.hashLocation]);

	const expandMenuHandler = (e) => {
		e.preventDefault();
		const id = e.currentTarget.parentNode.id;

		setAboutExpanded((prevState) => (prevState === id ? false : id));
	};

	const scrollToHash = () => {
		let imagesLoaded = null;
		const hashLocation = props.hashLocation || window.location.hash;

		const allLoaded = () => {
			if (pageElement !== undefined) {
				const imgs = pageElement.current.querySelectorAll('img');
				imagesLoaded = [...imgs].length;

				[...imgs].forEach((img) => {
					if (img.complete) imagesLoaded -= 1;
				});
			}

			if (pageElement !== undefined && imagesLoaded === 0) {
				setTimeout(() => {
					const position = offset(document.getElementById(hashLocation.replace('#', ''))).top - 80;
					scrollTo(500, position);
				}, 300);
			} else {
				setTimeout(allLoaded, 50);
			}
		};

		allLoaded();
	};

	if (!data || !data.content) return null;

	let content = data.content;
	let metaInfo = {};

	const pageClasses = [s.page_inner];
	if (data.addMenu) pageClasses.push(s.page_inner__withMenu);

	if (Array.isArray(data.content) && data.content[0] && data.content[0]?.restrict) {
		content = data.content[0].restrict.indexOf(setup.language) === -1 ? data.content[0] : data.content[1];
		metaInfo = content;
	} else if (data.content?.meta?.default) {
		metaInfo = translateObjectDefaultData(setup, data.content.meta);
	}

	return (
		<main role="main">
			<Top setup={setup} pageContent={metaInfo} paths={data.paths} />
			<div className={[s.page, (data.section && content.excerpt ? s[`page__${data.section}`] : null), ...(metaInfo.tags ? Object.keys(metaInfo.tags).map((t) => s[`page__${t}`]) : [])].join(' ')} ref={pageElement}>
				{
					data.addMenu ? (
						<div className={s.page_menu}>
							{
								footer.footerMenu.map((menu) => {
									if (!menu.showForCustomerService) return null;
									const id = urlify(menu.columnHeader.text);
									return (
										<ul key={id} id={id} className={[s.page_menu_column, ...(aboutExpanded === id ? [s.page_menu_column__open] : [])].join(' ')}>
											<a href="#expandMenu" onClick={expandMenuHandler} className={s.page_menu_column_headline}><h5>{ translate(setup, menu.columnHeader) }</h5></a>
											{
												menu.columnLinks.map((link) => (
													<Link className={[s.page_menu_column_link, ...(currentPath === translate(setup, link.link).slice(1) ? [s.page_menu_column_link__active] : [])].join(' ')} key={urlify(link.link.text)} to={prefix(setup, translate(setup, link.link))}><span>{translate(setup, link.linkText)}</span></Link>
												))
											}
										</ul>
									);
								})
							}
						</div>
					) : null
				}
				<div className={pageClasses.join(' ')}>
					{
						data.section && content.excerpt && (
							<div className={s.page_inner_top}>
								<h4 className={s.page_inner_top_preHeader}>
									{
										Object.keys(metaInfo.tags).map((tag) => {
											const tagMeta = translateObjectData(setup, metaInfo.tags[tag]);
											return tagMeta.title || tagMeta.name;
										}).join(', ')
									}
								</h4>
								<h1 className={s.page_inner_top_header}>{ translate(setup, metaInfo.title) }</h1>
							</div>
						)
					}
					<div>
						{ content?.section && <TemplateParserDeprecated sections={content.section} setup={setup} /> }
						{ content?.excerpt && <TemplateParser sections={content.excerpt} setup={setup} /> }
						{ content?.sections && <TemplateParser sections={content.sections} setup={setup} /> }
						{ content.event ? <Event content={content.event} setup={setup} currentPath={currentPath} /> : null }
					</div>
				</div>
			</div>
		</main>
	);
};

const mapState = ({ environment }, { data, currentPath }) => ({
	data,
	currentPath,
	hashLocation: environment.hashLocation,
	footer: environment.footer,
	setup: environment.setup,
});

export default hot(module)(connect(mapState)(Page));
